import './index.css'

const ScoreCard = props => {
  const {score, onResetGame} = props

  return (
    <div className="score-card-container">
      <img
        src="https://assets.ccbp.in/frontend/react-js/match-game-trophy.png"
        alt="trophy"
        className="trophy-img"
      />
      <p className="score-label">YOUR SCORE</p>
      <h1 className="final-score">{score}</h1>
      <button type="button" className="play-again-button" onClick={onResetGame}>
        <img
          src="https://assets.ccbp.in/frontend/react-js/match-game-play-again-img.png"
          alt="reset"
          className="reset-icon"
        />
        PLAY AGAIN
      </button>
    </div>
  )
}

export default ScoreCard
